import { styled } from "@mui/material/styles";
const DetailsWrap = styled("div")(({ theme }) => ({
  width: "80%",
  marginLeft: "auto",
  marginTop: "20px",
  [theme.breakpoints.down("md")]: {
    width: "100%",
  },
}));

const QuoteItem = styled("div")(({ theme }) => ({
  width: "100%",
  margin: "auto",
  marginTop: "50px",
  "& .Quote_ItemMain": {
    display: "flex",
    alignItems: "center",
    marginBottom: "15px",
    gap: "20px",
    "& span": {
      fontStyle: "normal",
      fontWeight: 900,
      fontSize: "16px",
      lineHeight: "28px",
      color: "#0B0B0B",
      fontFamily: theme.typography.fontFamily,
    },
    [theme.breakpoints.down("md")]: {
      flexWrap: "nowrap",
      gap: "10px",
    },
  },
  "& .date_ItemMain": {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginBottom: "15px",
    "& span": {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "17px",
      lineHeight: "28px",
      color: "rgba(11, 11, 11, 0.75)",
      fontFamily: theme.typography.fontFamily,
    },
    [theme.breakpoints.down("md")]: {
      flexWrap: "nowrap",
      gap: "10px",
    },
  },
  "& .many_orders": {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginBottom: "15px",
    "& span": {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "18px",
      lineHeight: "28px",
      color: "rgba(11, 11, 11, 0.75)",
      fontFamily: theme.typography.fontFamily,
    },
    [theme.breakpoints.down("md")]: {
      flexWrap: "nowrap",
      gap: "10px",
    },
  },
  "& .orders_image": {
    display: "flex",
    alignItems: "start",
    gap: "20px",
    marginBottom: "15px",
    "& img.orderImg": {
      width: "92px",
      height: "69px",
      borderRadius: "5px",
    },
    [theme.breakpoints.down("md")]: {
      flexWrap: "nowrap",
      gap: "10px",
    },
    "& .orders_image_items": {
      display: "flex",
      gap: "10px",
      flexWrap: "wrap",
    },
  },
  "& .pickup_ItemMain": {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginBottom: "20px",
    position: "relative",
    "&::after": {
      content: '""',
      position: "absolute",
      left: "13px",
      top: "100%",
      height: "64%",
      width: "1px",
      borderLeft: "2px dashed rgba(11, 11, 11, 0.5)",
    },
    "& span": {
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "18px",
      lineHeight: "18px",
      color: "#0B0B0B",
      fontFamily: theme.typography.fontFamily,
    },
    [theme.breakpoints.down("md")]: {
      flexWrap: "nowrap",
      gap: "10px",
    },
  },
  "& .drop_ItemMain": {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginBottom: "15px",
    "& span": {
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "18px",
      lineHeight: "18px",
      color: "#0B0B0B",
      fontFamily: theme.typography.fontFamily,
    },
    [theme.breakpoints.down("md")]: {
      flexWrap: "nowrap",
      gap: "10px",
    },
  },
}));

const MapMain = styled("div")(({ theme }) => ({
  height: "260px",
  overflow: "hidden",
  marginTop: "25px",
  marginBottom: "50px",
  "& img": { height: "auto", width: "100%" },
}));

export { DetailsWrap, QuoteItem, MapMain };
